/*!
 * Copyright © 2018-2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyDialogModule } from '@angular/material/legacy-dialog';
import { MatLegacySelectModule as MatSelectModule } from '@angular/material/legacy-select';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { GoogleMapsLightModule } from '../google-maps-light';
import { TabsModule } from '../tabs';
import { NotificationComponent } from './notification';
import { NotificationDetailsComponent } from './notification-details';
import { NotificationsIconModule } from './notifications-icon.module';
import { NotificationsComponent } from './notifications.component';
import { BoldWrapPipe } from './pipes';
import { AlertService, NotificationsService, RedirectService } from './services';
import { NotificationsEffects, NotificationsReducer } from './store';

@NgModule({
  imports: [
    CommonModule,
    NotificationsIconModule,
    ReactiveFormsModule,
    FormsModule,
    TabsModule,
    GoogleMapsLightModule,
    StoreModule.forFeature('notificationsFeature', NotificationsReducer),
    EffectsModule.forFeature([NotificationsEffects]),
    MatIconModule,
    MatLegacyDialogModule,
    MatLegacyButtonModule,
    MatSelectModule
  ],
  declarations: [NotificationsComponent, NotificationComponent, BoldWrapPipe, NotificationDetailsComponent],
  exports: [NotificationsComponent, NotificationComponent],
  providers: [NotificationsService, RedirectService, AlertService]
})
export class NotificationsModule {}
